/**
 * 転職支援サービス利用区分（wtsrfl）で「サービス利用中」を表すステータス
 */
export const AGENT_SERVICE_IN_USE = 2;

/**
 * エージェントサービスに申し込むUIに必要なデータを返すフック
 * @param agentServiceState 転職支援サービス利用区分（wtsrfl）
 * @returns {boolean} エージェントサービスに申し込むの表示フラグ
 */
export const useAgentService = (agentServiceState: number | undefined) => {
  const shouldShowAgentService = agentServiceState !== AGENT_SERVICE_IN_USE;

  return {
    shouldShowAgentService,
  };
};
